import React from "react";
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router'

export default class NavigationListItem extends React.Component {

    constructor(props){
        super();

        this.state = {
            hasChildren : props.hasChildren || false,
            iconClassName :  props.iconClassName || '',
            defaultTranslation :  props.defaultTranslation || '',
            translationId :  props.translationId || '',
            path   : props.path || false,
            onClick : props.onClick || function(){}
        }
    }

    renderIcon(){
        if(!this.state.iconClassName || 0 === this.state.iconClassName.length) return;

        return (<i className={"palette-Branding Primary text zmdi "+this.state.iconClassName}></i>)
    }

    renderBody(){

    }
    render(){

        return (
            <Link onClick={this.state.onClick} to={this.props.path} role="button" className="palette-Branding Primary text"  data-ma-action={ this.state.hasChildren === false ? "" : "submenu-toggle" } >
                {this.renderIcon()}
                <FormattedMessage id={ "ui-"+this.state.translationId } defaultMessage={ this.state.defaultTranslation } />
            </Link>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/layouts/navigation-list-item.js